module.exports = __webpack_public_path__ + "static/media/user-md.f89212fc.svg";